import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";

import CarItem from "../common/caritem";

const PropsCars = ({ totalCars, featureCars, stype, totalTripsFull }) => {
	return (
		<div className="content">
			<Swiper
				className="swiper-list-car"
				modules={[Navigation, Pagination]}
				slidesPerView={1}
				spaceBetween={10}
				pagination={{
					el: ".pagi-car",
					clickable: true,
					dynamicBullets: true,
				}}
				navigation={{
					nextEl: ".list-car-next" + stype,
					prevEl: ".list-car-prev" + stype,
				}}
				breakpoints={{
					1200: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					992: {
						slidesPerView: 1.6,
						spaceBetween: 20,
					},
					768: {
						slidesPerView: 2,
						spaceBetween: 10,
					},
					481: {
						slidesPerView: 1.2,
					},
				}}>
				{featureCars.map((featureCar, i) => (
					<SwiperSlide key={i}>
						<CarItem car={featureCar} stype={stype} relatedCar={true} fav={false} totalTripsFull={totalTripsFull} />
					</SwiperSlide>
				))}
				<div className="swiper-pagination pagi-car" />
			</Swiper>

			<div
				className={`swiper-button-prev list-car-prev${stype} ${
					totalCars < 2 ? "swiper-button-disabled swiper-button-lock" : ""
				}`}
			/>
			<div
				className={`swiper-button-next list-car-next${stype} ${
					totalCars < 2 ? "swiper-button-disabled swiper-button-lock" : ""
				}`}
			/>
		</div>
	);
};

export default PropsCars;
